export default __webpack_public_path__ + "static/media/firstcommunity.945a2c76.svg";